import React, { useState } from 'react';

function Gallery({ images }) {
  const [selectedImage, setSelectedImage] = useState(null);

  if (images.length === 0) {
    return (
      <div className="sd-gallery-panel">
        <div className="sd-panel-header">
          <h2>🎨 图片画廊 Gallery</h2>
        </div>
        <div className="sd-gallery-empty">
          <span>📭</span>
          <p>还没有生成的图片</p>
          <span className="hint">生成的图片将自动保存在这里</span>
        </div>
      </div>
    );
  }

  return (
    <div className="sd-gallery-panel">
      <div className="sd-panel-header">
        <h2>🎨 图片画廊 Gallery ({images.length})</h2>
      </div>

      <div className="sd-gallery-grid">
        {images.map((item, index) => (
          <div key={index} className="sd-gallery-item" onClick={() => setSelectedImage(item)}>
            <img src={item.image} alt={`Generated ${index + 1}`} />
            <div className="sd-gallery-item-overlay">
              <p>{item.prompt || '无提示词'}</p>
            </div>
          </div>
        ))}
      </div>

      {selectedImage && (
        <div className="sd-modal-overlay" onClick={() => setSelectedImage(null)}>
          <div className="sd-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="sd-modal-close" onClick={() => setSelectedImage(null)}>✕</button>
            <img src={selectedImage.image} alt="Selected" />
            <div className="sd-modal-info">
              <h3>生成信息</h3>
              <div className="sd-info-grid">
                <div className="sd-info-item">
                  <label>提示词</label>
                  <p>{selectedImage.prompt || '无'}</p>
                </div>
                {selectedImage.info && (
                  <>
                    <div className="sd-info-item">
                      <label>种子</label>
                      <p>{selectedImage.info.seed}</p>
                    </div>
                    <div className="sd-info-item">
                      <label>采样器</label>
                      <p>{selectedImage.info.sampler_name}</p>
                    </div>
                    <div className="sd-info-item">
                      <label>步数</label>
                      <p>{selectedImage.info.steps}</p>
                    </div>
                    <div className="sd-info-item">
                      <label>CFG Scale</label>
                      <p>{selectedImage.info.cfg_scale}</p>
                    </div>
                    <div className="sd-info-item">
                      <label>尺寸</label>
                      <p>{selectedImage.info.width} × {selectedImage.info.height}</p>
                    </div>
                  </>
                )}
                <div className="sd-info-item">
                  <label>生成时间</label>
                  <p>{new Date(selectedImage.timestamp).toLocaleString()}</p>
                </div>
              </div>
              <a href={selectedImage.image} download={`sd-${Date.now()}.png`} className="sd-download-btn">
                📥 下载图像
              </a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Gallery;

